import { makeGenericApiAction } from './shared/helpers';

export const fetchDietaryTagsAction = (payload) => async (dispatch) => {
  makeGenericApiAction({
    action: 'FETCH_DIETARY_TAGS',
    model: 'dietaryTags',
    dispatch,
    method: 'get',
    path: 'bookings/getAllDietaryTags',
    errorMessage: 'an error occurred while retrieving dietary tags.',
    payload,
    extractModel: true,
  });
};
